import { ChangeDetectionStrategy, Component, input, Input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-email-input',
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './email-input.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmailInputComponent {
  control = input<FormControl>(new FormControl<string>(''));
  label = input<string>('Correo electrónico');
  placeholder = input<string>(' ');
  showErrors = input<boolean>(false);
}
